/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetUploadIcon20Solid = forwardRef('NetUploadIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.205 7.434a1.25 1.25 0 1 1-1.66-1.868l4.379-3.893a3.125 3.125 0 0 1 4.152 0l4.38 3.893a1.25 1.25 0 0 1-1.662 1.868l-3.544-3.15v8.966a1.25 1.25 0 0 1-2.5 0V4.284l-3.545 3.15Z" }),
        React.createElement("path", { d: "M1.75 17c0-.69.56-1.25 1.25-1.25h14a1.25 1.25 0 0 1 0 2.5H3c-.69 0-1.25-.56-1.25-1.25Z" })));
});
